import * as React from "react";
import { Button, Intent } from "@blueprintjs/core";
import Link from "next/link";
import { humanBaseSize } from "../../utils/size";
import { AssemblyDerivedMetadata, BasicGenome } from "../../api";
import GenericLinkCard from "../generic-link-card";
import { cleanTaxaName } from "../../utils/genomes";

type GenomeCardProps = {
  assembly: {
    uuid: string;
    derived_metadata: AssemblyDerivedMetadata;
    genome: BasicGenome;
  };
  similarity: string;
  className?: string;
  onMouseOver?: () => void;
  onMouseLeave?: () => void;
};

const GenomeCard = ({
  className = "",
  assembly,
  similarity,
  onMouseOver,
  onMouseLeave,
}: GenomeCardProps) => {
  const { genome, derived_metadata } = assembly;
  const size = derived_metadata.length;
  const numContigs = derived_metadata.contig_lengths.length;
  return (
    <GenericLinkCard
      className={`genome-card ${className}`}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      header={
        <>
          <span className="genome-card__name">
            <em>{cleanTaxaName(genome.taxon_name)}</em> ({genome.name})
          </span>
          <span className="genome-card__similarity">{similarity}</span>
        </>
      }
      metadata={
        <>
          <span>
            <strong>
              {numContigs} contig{numContigs > 1 && "s"}
            </strong>
          </span>
          <span>{humanBaseSize(size)}</span>
        </>
      }
      link={
        <Link as={`/genomes/${genome.uuid}`} href={`/genomes/[uuid]`}>
          <Button icon="document" text="View Genome" intent={Intent.PRIMARY} large={true} />
        </Link>
      }
    />
  );
};

export default GenomeCard;
